import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {AbstractSigaleComponent} from '../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'champs-saisie-temps',
	templateUrl: './champs-saisie-temps.html',
	styleUrls: ['./champs-saisie-temps.scss'],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule
	]
})
export class ChampsSaisieTemps extends AbstractSigaleComponent {
	@Input() formParent: FormGroup;
	@Input() disabled = false;
	@ViewChild('input_heures', {static: true}) inputHeures: ElementRef;
	@ViewChild('input_minutes', {static: true}) inputMinutes: ElementRef;

	ngOnInit(): void {
		super.ngOnInit();
		this.changeHeures();
		this.changeMinutes();

		// @ts-ignore
		this.formParent.controls.heures.valueChanges.subscribe(() => {
			this.focusNextInputMinutes();
		});
	}

	getHeures(): string {
		return this.formParent.controls['heures'].value;
	}

	getMinutes(): string {
		return this.formParent.controls['minutes'].value;
	}

	setHeures(heures: string): void {
		this.formParent.controls['heures'].setValue(heures);
	}

	setMinutes(minutes: string): void {
		this.formParent.controls['minutes'].setValue(minutes);
	}

	/**
	 * Ajoute le 0 à gauche des heures si le nombres d'heures est < 10
	 */
	changeHeures(): void {
		if (this.getHeures() !== null && this.getHeures().toString().length === 1) {
			this.setHeures('0' + this.getHeures());
		}
	}

	/**
	 * Ajoute le 0 à gauche des minutes si le nombres de minutes est < 10
	 */
	changeMinutes(): void {
		if (this.getMinutes() !== null && this.getMinutes().toString().length === 1) {
			this.setMinutes('0' + this.getMinutes());
		}
	}

	/**
	 * Permet de passer le focus sur l'input minutes lorsque l'on a saisi 2 chiffres pour l'heure
	 */
	focusNextInputMinutes() {
		if (this.getHeures() && this.getHeures().toString().length === 2) {
			this.inputMinutes.nativeElement.focus();
			this.inputMinutes.nativeElement.select();
		}
	}

	/**
	 * Contrôle que la saisie est bien un chiffre et que le nombres d'heures ne dépasse pas 2 chiffres
	 * @param event l'event
	 */
	controleSaisieHeures(event): boolean {
		const charCode = (event.which) ? event.which : event.key;
		return !(charCode > 31 && (charCode < 48 || charCode > 57));
	}

	/**
	 * Contrôle que la saisie est bien un chiffre et que le nombres de minutes ne dépasse pas 2 chiffres
	 * @param event l'event
	 */
	controleSaisieMinutes(event): boolean {
		const charCode = (event.which) ? event.which : event.key;
		return !(charCode > 31 && (charCode < 48 || charCode > 57));

	}
}

/**
 * Validateur qui vérifie le nombre max saisi dans un input text.
 * Si le nombre est vide la saisie n'est pas valide non plus.
 * @param textNumber le nombre qui ne doit pas être dépassé
 * @param autoriserNombreVide true si l'on veut autoriser les nombre null, false sinon
 */
export function textNumberMaxValidator(textNumber: number, autoriserNombreVide: boolean = false): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const number = control.value !== '' ? parseInt(control.value, 10) : null;
		if (autoriserNombreVide && number === null) {
			return null;
		}
		const forbidden = number === null || textNumber < number;
		return forbidden ? {forbiddenNumber: {value: control.value}} : null;
	};
}
